export const styles = {
  sectionTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  sectionTitleIconBox: {
    width: 28,
    height: 28,
    borderRadius: 10,
    background: '#EEF2F7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  card: {
    borderRadius: 14,
    border: '1px solid #E5E7EB',
    background: '#F9FAFB',
    padding: 18,
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 0',
  },

  rowDivider: {
    borderBottom: '1px solid #E5E7EB',
  },

  leftIcon: {
    width: 28,
    height: 28,
    borderRadius: 10,
    background: '#EEF2F7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  rowTexts: {
    flex: 1,
    minWidth: 0,
  },

  title: {
    fontSize: 13,
    fontWeight: 700,
    color: '#111827',
    lineHeight: '18px',
  },

  desc: {
    fontSize: 12,
    fontWeight: 400,
    color: '#6B7280',
    lineHeight: '16px',
    marginTop: 2,
  },

  rightControl: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },

  numberInput: {
    width: 86,
    minWidth: 86,
    height: 32,
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    padding: '0 10px',
    textAlign: 'center',
    fontSize: 13,
    outline: 'none',
    background: '#FFFFFF',
    color: '#111827',
  },

  stepBtn: {
    width: 28,
    height: 28,
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    background: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16,
    lineHeight: '26px',
    color: '#111827',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    marginTop: 18,
  },

  switchWrap: {
    position: 'relative',
    width: 44,
    height: 24,
    borderRadius: 999,
    background: '#E5E7EB',
    cursor: 'pointer',
    border: '1px solid #D1D5DB',
  },
  switchWrapOn: {
    background: '#0F2744',
    border: '1px solid #0F2744',
  },
  switchKnob: {
    position: 'absolute',
    top: 2,
    left: 2,
    width: 20,
    height: 20,
    borderRadius: 999,
    background: '#FFFFFF',
    transition: 'transform 120ms ease',
  },
  switchKnobOn: {
    transform: 'translateX(20px)',
  },
};
